import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';

import {BrandDarkBlue} from '../theme';

// Define the type for the padding prop
interface ChartContainerProps {
	padding?: string;
}

// Use the type in the styled component
const ChartContainer = styled(Box)<ChartContainerProps>(({padding}) => ({
	padding: padding || '16px',
	background: BrandDarkBlue,
	borderRadius: '6px',
}));

export default ChartContainer;
